function transactionFiscalization(item, order_uid, card, trans_id, trans_uid) {
    let url = item.dataset.to_fiscalize_url;

    $.ajax({
        type: "POST",
        url: url,
        data: {
        "csrfmiddlewaretoken": $("input[name='csrfmiddlewaretoken']").prop("value"),
        "order_uid": $("input[name='order_uid']").prop("value"),
        "payment_card": item.dataset.card,
        "trans_id": item.dataset.trans_id,
        "trans_uid": item.dataset.trans_uid,
        "amount": $("input[name='product_price']").prop("value"),
        },
        success: function (response) {
            setTimeout(function () {
                alert(gettext('The transaction will be sent within 3 minutes'))
                location.reload();
            }, 2000);
        },
        error: function (response) {
            setTimeout(function () {
                alert(response.responseJSON.message)
                location.reload();
            }, 2000)
        }
    })
}

function setTransactionAttrs(trans_uid) {
    $("#confirm-trans-uid").val(trans_uid);
    $("#confirm-cancel-trans").modal("show");
    $("#trans-confirm-code-input").val("");
    $("#confirm-cancel-trans .alert.alert-danger").text("").hide();
}

function cancel_transaction() {
    let url = "/admin/transaction/cancel/";

    let trans_uid = $("#confirm-trans-uid").val();
    let comment = $("#trans-cancel-comment-input").val();
    let trans_confirm_code_input = $("#trans-confirm-code-input").val();

    $.ajax({
        type: "POST",
        url: url,
        data: {
            "csrfmiddlewaretoken": $("input[name='csrfmiddlewaretoken']").prop("value"),
            "trans_uid": trans_uid,
            "confirm_code": trans_confirm_code_input,
            "comment": comment,
        },
        success: function (response) {
            $("#cancel-trans-response-messages .alert").removeClass("alert-danger").addClass("alert-success").text(response.message).show();
            $("#trans-btn-" + response.trans_uid).attr("disabled", true);
        },
        error: function (response) {
            let message = response.responseJSON.message;
            $("#cancel-trans-response-messages .alert").removeClass("alert-success").addClass("alert-danger").html('<p style="margin-bottom: 0;">' + message + '</p>').show();
        }
    })
}